import React, { lazy, Suspense } from 'react';
import type { LoginModalProps } from './LoginModalView';

const LoginModalView = lazy(() => import('./LoginModalView').then((m) => ({ default: m.LoginModalView })));

export const LoginModal: React.FC<LoginModalProps> = (props) => (
  <Suspense fallback={null}>
    <LoginModalView {...props} />
  </Suspense>
);

export type { LoginModalProps } from './LoginModalView';
